import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { type Contig } from "../../../graphql.js";

export interface IContigAnnotationCardProps extends GridCard {
  contig: Contig;
}

const ContigAnnotationCard: FC<IContigAnnotationCardProps> = (props) => {
  if (!props.contig || !props.contig.contigStatistics) {
    return null;
  }

  const stats = props.contig.contigStatistics;
  const variantCounts = stats.variantCounts;

  return (
    <Card key="genome-info-card" title={"Contig Annotations"}>
      <CardRowSimple label={"Size"} value={formatNumberByThousands(stats.contigSize) + " bp"} />
      <CardRowSimple label={"Genes"} value={formatNumberByThousands(stats.geneCount)} />
      <CardRowSimple label={"Proteins"} value={formatNumberByThousands(stats.proteinsCount)} />
      <CardRowSimple label={"Transcripts"} value={formatNumberByThousands(stats.transcriptsCount)} />
      <CardRowSimple label={"Point mutations"} value={formatNumberByThousands(variantCounts.point)} />
      <CardRowSimple label={"InDel mutations"} value={formatNumberByThousands(variantCounts.indel)} />
      <CardRowSimple label={"Deletions"} value={formatNumberByThousands(variantCounts.deletion)} />
      <CardRowSimple label={"Insertions"} value={formatNumberByThousands(variantCounts.insertion)} />
      <CardRowSimple
        label={"Translocation deletions"}
        value={formatNumberByThousands(variantCounts.translocationDeletion)}
      />
      <CardRowSimple
        label={"Translocation insertions"}
        value={formatNumberByThousands(variantCounts.translocationInsertion)}
      />
    </Card>
  );
};

export { ContigAnnotationCard };
